import { defineMessages } from 'react-intl'

/**
 * Shared i18n message descriptors for tier progression notification (desktop and mobile).
 */
export const tierProgressionNotificationMessages = defineMessages({
  headerWithName: {
    id: 'mDS7C1q5mvTmVdaeopD9',
    defaultMessage: '{userName}, you’re so close to {tierName} status',
    description: 'Tier progression notification header when user name is known',
  },
  headerDefault: {
    id: 'JJgd2PZxRM4JybNtBhvi',
    defaultMessage: 'You’re so close to {tierName} status',
    description: 'Tier progression notification header when user name is not known',
  },
  viewProgress: {
    id: 'Tz9gAu1Iwpi6ZNMHPmZK',
    defaultMessage: 'View my progress',
    description: 'Button text to navigate to loyalty tier progress in tier progression notification',
  },
  closeAriaLabel: {
    id: 'HaW45W3RyemiwIBikVmf',
    defaultMessage: 'Close',
    description: 'Aria label for close button in tier progression notification',
  },
})
